import React from "react";
import LoginView from "../auth-views/LoginView";
import RegisterView from "../auth-views/RegisterView";
import PasswordRecoveryRequestView from "../auth-views/PasswordRecoveryRequestView";
import PasswordRecoveryEmailSentView from "../auth-views/PasswordRecoveryEmailSentView";
import PasswordResetView from "../auth-views/PasswordResetView";
import PasswordResetSuccessView from "../auth-views/PasswordResetSuccessView";
import IdentifierView from "./IdentifierView";
import PhoneVerificationView from "./PhoneVerificationView";

import { User } from "../../services/authService";

export type AuthView = "identifier" | "login" | "register" | "reset" | "phone-otp" | "password-recovery-request" | "password-recovery-email-sent" | "password-reset" | "password-reset-success";

interface AuthViewRouterProps {
	currentView: AuthView;
	onSwitchView: (view: AuthView) => void;
	onContinue?: (identifier: string, type: "email" | "phone" | "unknown") => void;
	onVerify: (code: string) => Promise<void>;
	onMobileIdSuccess?: (user?: User, isNewUser?: boolean) => void;
	identifier: string;
	identifierType: "email" | "phone" | "unknown";
	phoneExists: boolean | null;
	isCheckingIdentifier: boolean;
	phone: string;
	recoveryEmail?: string;
}

const AuthViewRouter: React.FC<AuthViewRouterProps> = ({ currentView, onSwitchView, onContinue, onVerify, onMobileIdSuccess, identifier, identifierType, isCheckingIdentifier, phone, recoveryEmail }) => {
	switch (currentView) {
		case "identifier":
			return <IdentifierView onContinue={onContinue} isCheckingIdentifier={isCheckingIdentifier} />;
		case "login":
			return <LoginView onSwitchView={onSwitchView} identifier={identifier} />;
		case "register":
			return <RegisterView identifier={identifier} identifierType={identifierType} />;
		case "phone-otp":
			return <PhoneVerificationView phone={phone} onSwitchView={onSwitchView} onVerify={onVerify} onMobileIdSuccess={onMobileIdSuccess} />;
		case "password-recovery-request":
			return <PasswordRecoveryRequestView email={identifier || ""} />;
		case "password-recovery-email-sent":
			return <PasswordRecoveryEmailSentView email={recoveryEmail || ""} />;
		case "password-reset":
			return <PasswordResetView />;
		case "password-reset-success":
			return <PasswordResetSuccessView onSwitchView={onSwitchView} />;
		default:
			return null;
	}
};

export default AuthViewRouter;
